import React, { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import axios from "axios";
import summaryApi from "../common/index";
import "./UserProfile.css";
import Loading from "../loading"; // Make sure the path is correct
import { toast } from "react-hot-toast";
import uploadImage from "../helpers/uploadImage";

const UserProfile = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [user, setUser] = useState({
    name: "",
    email: "",
    profilePic: "",
    role: "",
    createdAt: "",
  });
  // const [profilePicFile, setProfilePicFile] = useState(null); // profilePicFile not used, only setter
  const [profilePicPreview, setProfilePicPreview] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [confirmEmail, setConfirmEmail] = useState("");
  const [orders, setOrders] = useState([]);
  const [showOrders, setShowOrders] = useState(false);

  // const [hasViewedStatusUpdate, setHasViewedStatusUpdate] = useState(false); // Not currently used

  // const handleShowOrders = () => {
  //   setShowOrders(true);
  //   setHasViewedStatusUpdate(true);
  // }; // Not currently used

  const getStatusClass = (status) => {
    switch (status) {
      case "Pending":
        return "status-pending";
      case "Shipped":
        return "status-shipped";
      case "Delivered":
        return "status-delivered";
      case "Cancelled":
        return "status-cancelled";
      default:
        return "";
    }
  };

  useEffect(() => {
    const fetchUserProfile = async () => {
      if (!id) {
        setError("User ID is missing");
        setLoading(false);
        return;
      }

      try {
        const response = await axios({
          url: summaryApi.userProfile(id).url,
          method: summaryApi.userProfile(id).method,
          withCredentials: true,
        });
        setUser(response.data.data);
        setLoading(false);
      } catch (error) {
        setError(error.response?.data?.message || error.message);
        setLoading(false);
      }
    };

    const fetchOrders = async () => {
      try {
        const response = await axios({
          url: summaryApi.getUserOrders.url,
          method: summaryApi.getUserOrders.method,
          withCredentials: true,
        });
        setOrders(response.data.data);
      } catch (error) {
        setError(error.response?.data?.message || error.message);
      }
    };

    fetchUserProfile();
    fetchOrders();
  }, [id]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setUser((prevUser) => ({
      ...prevUser,
      [name]: value,
    }));
  };
 const handleFileChange = async (e) => {
  const file = e.target.files && e.target.files[0];
  if (!file) return;

  setProfilePicPreview(URL.createObjectURL(file)); // local preview

  // Upload to Cloudinary
  const uploaded = await uploadImage(file);
  if (uploaded?.secure_url) {
    setUser(prev => ({ ...prev, profilePic: uploaded.secure_url })); // set URL for backend
    toast.success("Image uploaded successfully!");
  } else {
    toast.error("Failed to upload image to Cloudinary");
  }
};

  const handleRemoveNewImage = () => {
    if (profilePicPreview) {
      URL.revokeObjectURL(profilePicPreview); // ✅ cleanup
    }
    // setProfilePicFile(null); // Not currently used
    setProfilePicPreview(null);
  };

 const handleUpdateUser = async (e) => {
  e.preventDefault();

  const payload = {
    name: user.name,
    email: user.email,
    profilePic: user.profilePic, // Cloudinary URL
  };

  try {
    setLoading(true);
    const response = await axios({
      url: summaryApi.updateUserDetails(id).url,
      method: summaryApi.updateUserDetails(id).method,
      data: payload,
      withCredentials: true,
    });
    setUser(response.data.data);
    setLoading(false);
    toast.success(response.data.message, {
      position: "top-center",
      autoClose: 3000,
      style: {
        background: "linear-gradient(to right, #4a90e2, #9013fe)",
        color: "#fff",
      },
    });
    window.location.reload();
  } catch (error) {
    setError(error.response?.data?.message || error.message);
    setLoading(false);
    toast.error(error.response?.data?.message || error.message, {
      style: {
        background: "linear-gradient(to right, #e94e77, #ff6b6b)",
        color: "white",
      },
    });
  }
};


  const handleDeleteUser = async () => {
    if (confirmEmail !== user.email) {
      toast.error("Email does not match");
      return;
    }

    try {
      setLoading(true);
      const response = await axios({
        url: summaryApi.deleteUser(id).url,
        method: summaryApi.deleteUser(id).method,
        withCredentials: true,
      });
      setLoading(false);

      toast.success(response.data.message || "User deleted successfully!");
      navigate("/");
      window.location.reload();
    } catch (error) {
      setError(error.response?.data?.message || error.message);
      setLoading(false);

      toast.error(error.response?.data?.message || "❌ Failed to delete user");
    }
  };

  if (loading) return <Loading />; // Use Loading component here
  if (error) return <div>Error: {error}</div>;

  return (
    <div className="user-profile-container">
      <div className="user-profile-sidebar">
        <h2 className="sidebar-heading">Account Settings</h2>
        <ul className="sidebar-menu">
          <li className="sidebar-item">
            <span>User Profile</span>
          </li>
          <Link to="/forgot-password" className="sidebar-item">
            <span>Change Password</span>
          </Link>
          <li className="sidebar-item">
            <button
              onClick={() => setShowOrders(true)}
              className="btn-view-orders"
            >
              Track Your Orders
            </button>
          </li>
        </ul>
        <div className="sidebar-info">
          <p>
            <strong>Current User:</strong> {user.name}
          </p>
          <p>
            <strong>Email:</strong> {user.email}
          </p>
          <p>
            <strong>Role:</strong> {user.role}
          </p>
        </div>
      </div>

      <div className="user-profile-details">
        <h2 className="text-gray-700">
          Hey Welcome Back <span className="text-blue-600">{user.name}</span> 💫
        </h2>
        <h1 className="details-heading">Personal Information</h1>
        <form onSubmit={handleUpdateUser} className="user-form">
          <div className="form-group">
            <label htmlFor="name">Your Name *</label>
            <input
              type="text"
              id="name"
              name="name"
              value={user.name}
              onChange={handleInputChange}
              required
              className="form-input"
            />
          </div>
          <div className="form-group">
            <label htmlFor="email">Email *</label>
            <input
              type="email"
              id="email"
              name="email"
              value={user.email}
              onChange={handleInputChange}
              required
              className="form-input"
            />
          </div>

 <div className="form-group">
  <label className="block mb-2 font-semibold">Profile Picture</label>

  {/* Existing Image */}
  {user.profilePic && (
    <div className="existing-pic mb-4">
      <p className="text-sm text-gray-600 mb-1">Current Picture</p>
      <img
        src={
          user.profilePic.startsWith("http")
            ? user.profilePic
            : `https://dates-website-backend.vercel.app/${user.profilePic}`
        }
        alt="Current Profile"
        className="profile-pic-preview w-24 h-24 rounded-full object-cover border"
      />
    </div>
  )}

  {/* Hidden File Input */}
  <input
    type="file"
    id="profilePic"
    name="profilePic"
    accept="image/*"
    onChange={handleFileChange}
    className="hidden"
  />

  {/* New Image Preview */}
  {profilePicPreview && (
    <div className="new-pic mb-4 relative">
      <p className="text-sm text-gray-600 mb-1">New Selected Picture</p>
      <img
        src={profilePicPreview}
        alt="New Profile Preview"
        className="profile-pic-preview w-24 h-24 rounded-full object-cover border-2 border-blue-500"
      />
      <button
        type="button"
        onClick={handleRemoveNewImage}
        className="absolute top-0 right-0 bg-red-500 text-white w-5 h-5 flex items-center justify-center rounded-full text-sm"
      >
        &times;
      </button>
    </div>
  )}

  {/* Buttons */}
  <div className="flex flex-col sm:flex-row sm:space-x-3 sm:space-y-0 space-y-3">
    <button
      type="button"
      onClick={() => document.getElementById("profilePic").click()}
      className="px-3 py-1 bg-gray-500 text-white rounded-md hover:bg-gray-600 focus:outline-none"
    >
      Select Image
    </button>

    {profilePicPreview && (
      <button
        type="submit"
        className="px-3 py-1 bg-green-500 text-white rounded-md hover:bg-green-600 focus:outline-none"
      >
        Update Profile Picture
      </button>
    )}
  </div>
</div>


          <div className="form-group">
            <label htmlFor="role" className="role-group">
              Role{" "}
            </label>
            <span className="readonly-note">
              {" "}
              (This field is unchangeable. Please contact Admin for further
              info)
            </span>
            <input
              type="text"
              id="role"
              name="role"
              value={user.role}
              readOnly
              className="form-input readonly-input"
            />
          </div>
          <div className="form-group">
            <label htmlFor="createdAt">Created At</label>
            <input
              type="text"
              id="createdAt"
              name="createdAt"
              value={new Date(user.createdAt).toLocaleDateString()}
              readOnly
              className="form-input readonly-input"
            />
          </div>
          <button type="submit" className="btn-save">
            Update Profile
          </button>
          <button
            type="button"
            className="btn-delete"
            onClick={() => setShowDeleteModal(true)}
          >
            Delete User
          </button>
        </form>
      </div>
      {showDeleteModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h2>Confirm Delete</h2>
            <p>To confirm deletion, please enter the user's email:</p>
            <input
              type="email"
              value={confirmEmail}
              onChange={(e) => setConfirmEmail(e.target.value)}
              className="form-input"
            />
            <div>
              <button className="btn-delete-confirm" onClick={handleDeleteUser}>
                Delete User
              </button>
              <button
                className="btn-cancel"
                onClick={() => setShowDeleteModal(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {showOrders && (
        <div className="modal">
          <div className="modal-content order-modal-content">
            <span className="close" onClick={() => setShowOrders(false)}>
              &times;
            </span>
            <h2>Order Details</h2>
            {orders.length === 0 ? (
              <p>No orders found</p>
            ) : (
              orders.map((order) => (
                <div
                  key={order._id}
                  className={`order-item ${getStatusClass(order.status)}`}
                >
                  <h3>Order ID: {order._id}</h3>
                  <p>
                    Ordered Date:{" "}
                    {new Date(order.createdAt).toLocaleDateString()}
                  </p>
                  <p>Status: {order.status}</p>
                  <ul>
                    {order.items.map((item) => (
                      <li key={item._id}>
                        {item.name} - Quantity: {item.quantity}
                      </li>
                    ))}
                  </ul>
                  <p>Total Amount: £ {order.totalAmount}</p>
                </div>
              ))
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default UserProfile;
